import {useEffect} from 'react';
import ReportUtils from "../../../../../utils/report-utils.js";

const ResponsibleBoDetailsContent = ({ data, boName }) => {

    useEffect(() => {
        const labels = [
            "Responsável",
            `${boName}`,
            "Naturezas",
            "Data de criação",
            "Status"
        ];

        const values = data.responsibleBoDetails.map(element => [
            element.leader,
            element.id,
            element.reason_name,
            element.dt_create,
            element.status
        ]);

        ReportUtils.createExportableTable(labels, values, "Informações gerais");

    }, [data]);

    return null;
};

export default ResponsibleBoDetailsContent;